import { AiCitationStrip } from './AiCitationChip.jsx';
import { useOptionalRichTooltipController } from '../richTooltips/RichTooltipProvider.jsx';

const REVIEW_TONES = {
  pending_human_review: 'amber',
  approved_for_export: 'sage',
  human_reviewed: 'blue',
  reject: 'brick',
  rejected: 'brick',
  needs_rework: 'amber',
};

const REVIEW_LABELS = {
  pending_human_review: 'Pending review',
  approved_for_export: 'Approved for export',
  human_reviewed: 'Human reviewed',
  reject: 'Rejected',
  rejected: 'Rejected',
  needs_rework: 'Needs rework',
};

export function AiRunQueueCard({ run, onApprove, onRework, onReject, onOpen, busy }) {
  const tooltip = useOptionalRichTooltipController();
  const tone =
    REVIEW_TONES[run.reviewState || run.humanReviewState || 'pending_human_review'] || 'slate';
  const reviewTriggerProps =
    run.reviewTooltip && tooltip
      ? tooltip.getTriggerProps({
          surfaceId: run.reviewTooltip.surfaceId,
          payload: run.reviewTooltip,
          testIdPrefix: 'rich-tooltip',
          ariaLabel: `${run.id} review state details`,
        })
      : {};
  const confidenceTriggerProps =
    run.confidenceTooltip && tooltip
      ? tooltip.getTriggerProps({
          surfaceId: run.confidenceTooltip.surfaceId,
          payload: run.confidenceTooltip,
          testIdPrefix: 'rich-tooltip',
          ariaLabel: `${run.id} confidence details`,
        })
      : {};
  const ReviewTag = run.reviewTooltip ? 'button' : 'span';
  const ConfidenceTag = run.confidenceTooltip ? 'button' : 'div';
  return (
    <article className="ai-run-card">
      <header className="row spread">
        <div>
          <div className="eyebrow">{run.agentId || 'AI Agent'}</div>
          <h4 className="ai-run-title">{run.title || run.summary?.slice(0, 80) || run.id}</h4>
        </div>
        <div className="row">
          <ReviewTag
            type={run.reviewTooltip ? 'button' : undefined}
            className={`chip ${tone} sm${run.reviewTooltip ? ' ai-run-state-trigger' : ''}`}
            data-testid={`ai-run-state-${run.id}`}
            {...reviewTriggerProps}
          >
            {(() => {
              const k = run.reviewState || run.humanReviewState || 'pending_human_review';
              return REVIEW_LABELS[k] || k.replace(/_/g, ' ');
            })()}
          </ReviewTag>
          {run.modelId ? (
            <span className="chip outline sm">model {run.modelId.split('/').pop()}</span>
          ) : null}
        </div>
      </header>
      {run.summary ? <p className="ai-run-summary">{run.summary}</p> : null}
      {run.confidence != null ? (
        <ConfidenceTag
          type={run.confidenceTooltip ? 'button' : undefined}
          className="row ai-run-confidence-trigger"
          style={{ gap: 8 }}
          data-testid={`ai-run-confidence-${run.id}`}
          {...confidenceTriggerProps}
        >
          <span className="eyebrow">Confidence</span>
          <div className="score-bar" style={{ width: 160 }}>
            <i style={{ width: `${Math.min(100, Math.round((run.confidence || 0) * 100))}%` }} />
          </div>
          <span className="mono small">{Math.round((run.confidence || 0) * 100)}%</span>
        </ConfidenceTag>
      ) : null}
      {Array.isArray(run.citations) && run.citations.length ? (
        <AiCitationStrip citations={run.citations.slice(0, 3)} />
      ) : null}
      <footer className="ai-run-actions">
        <button className="btn ghost sm" onClick={() => onOpen && onOpen(run)}>
          View run
        </button>
        <button
          className="btn success sm"
          onClick={() => onApprove && onApprove(run)}
          disabled={busy}
        >
          Approve
        </button>
        <button className="btn ghost sm" onClick={() => onRework && onRework(run)} disabled={busy}>
          Needs rework
        </button>
        <button className="btn danger sm" onClick={() => onReject && onReject(run)} disabled={busy}>
          Reject
        </button>
      </footer>
    </article>
  );
}
